import { take, put, race, select } from 'redux-saga/effects'
import _ from 'lodash'
import { Record, List } from 'immutable'
import { SUCCESS, FAILED } from 'crom-api-constants'

import { loadGroupMembersRequest, setupGroupStack } from '../actions'

import { groupStackSelector, actualPagesSelector } from '../selectors'

import { LOAD_GROUP_MEMBERS_REQUEST } from '../constants'

const DEFAULT_COUNTRY = 'CZE'

const InitialMember = Record({
    address: '',
    dateOfBirth: '',
    country: DEFAULT_COUNTRY,
    entId: null,
    inacInd: '',
    name: '',
    regNbr: '',
    rowDt: '',
    typeCd: '',
})

const dataPath = 'success.payload.response.body'

export default function* groupStackMembersSaga(action) {
    const groupId = _.get(action, 'data.groupId', null)
    const page = _.get(action, 'data.page', null)

    const groupStackState = yield select(groupStackSelector)
    const membersPerPage = groupStackState.get('membersPerPage')
    const actualPages = yield select(actualPagesSelector)

    yield put(
        setupGroupStack(groupId, {
            page,
            rows: membersPerPage,
            pages: actualPages,
            members: List(),
            loading: true,
        })
    )

    yield put(loadGroupMembersRequest(groupId, page, Math.max(membersPerPage, 1))) // min of membersPerPage is 1

    const result = yield race({
        success: take(`${LOAD_GROUP_MEMBERS_REQUEST}_${SUCCESS}`),
        failed: take(`${LOAD_GROUP_MEMBERS_REQUEST}_${FAILED}`),
    })

    const { activeGroup } = yield select(groupStackSelector)

    const members = _.get(result, `${dataPath}.members`, []).map(
        (member) =>
            new InitialMember({
                ...member,
                entId: _.toString(_.get(member, 'entId', null)),
            })
    )
    const pages = _.get(result, `${dataPath}.pages`, 0)

    yield put(
        setupGroupStack(activeGroup, {
            members: List(members),
            loading: false,
            rows: membersPerPage,
            page,
            pages,
        })
    )

    return null
}
